export class BulkRestoreValidateResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<BulkRestoreValidateResponseItemsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkRestoreValidateResponse.attributeTypeMap;
    }
    constructor() {
    }
}
